import React, { ReactElement } from 'react'
import { Redirect } from 'react-router'
import { useSelector } from 'react-redux'
import ConfirmationPageText from './texts/ConfirmationPageText'
import { accept } from '../assets/images/images'
import { JOURNEY_COMPLETE_STATUSES, STATUS } from '../enums/common'
import Spinner from './Spinner'
import { IStore } from '../interfaces/Store'
import useInitHook from '../hooks/useInitHook'
import { ROUTES } from '../enums/routes'

function Confirmation(): ReactElement {
  const { journeyStatus } = useSelector(
    (state: IStore) => state.folderReducer.folder
  )
  const { status } = useInitHook()

  if (
    status === STATUS.loaded &&
    !JOURNEY_COMPLETE_STATUSES.includes(journeyStatus)
  ) {
    return <Redirect to={ROUTES.home} />
  }

  if (status !== STATUS.loaded) {
    return (
      <div className="relative pb3 pl3 mb3">
        <Spinner small={true} />
      </div>
    )
  }

  return (
    <>
      <img src={accept} alt="accept" className="mb25" />
      <h2 className="errorPageTitle mb5">
        Nous vous remercions <br />
        de votre confiance
      </h2>

      <ConfirmationPageText />
    </>
  )
}

export default Confirmation
